
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import swal from 'sweetalert';
import './Admin.css';
import logo from './../rcrm_logo.png';
import firebase from "firebase/app";

const Admin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const history = useHistory();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const userCredential = await firebase.auth().signInWithEmailAndPassword(email, password);
      const user = userCredential.user;
      
      sessionStorage.setItem("email", email);
      swal("Success", "Login successful", "success");
      history.push('/admin-dashboard'); // Redirect after login
    } catch (error) {
      swal("Authentication Failed", "Contact the system administrator for account registration.", "error");
    }
  };
  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   const { email, password } = e.target.elements;
  //   try {
  //     // await auth.login(email.value, password.value);
  //     // sessionStorage.setItem('email', email.value);
  //     // swal("Login Successful", "", "success");
  //     // history.push('/createexam'); // Redirect to a protected route
  //     // Firebase authentication
  //     await firebase.auth().signInWithEmailAndPassword(email.value, password.value);

  //     // Store session or token (optional)
  //     sessionStorage.setItem("email", email);
  //     swal("Login Successful", "", "success");
  //     // Redirect to the protected CreateExam page after successful login
  //     history.push('/createexam');
  //   } catch (error) {
  //     swal("Login Failed", "Please contact the admin to register.", "error");
  //   }
  // };

    // const handleSubmit = async (e) => {
    //   e.preventDefault();    
    //   const { email, password } = e.target.elements;
    
    //   try {
    //     // Sign in the user with Firebase Authentication
    //     const userCredential = await firebase.auth().signInWithEmailAndPassword(email.value, password.value);
    //     // Set the user to state and session storage
    //     const user = userCredential.user;
    //     setCurrentUser(user);
    //     sessionStorage.setItem("email", email.value);  // Save email to session
    //     // Redirect to '/createexam' after successful login
    //     if (auth.isAuthenticated()) {
    //         history.push("/createexam");  // Redirect if authenticated
    //     }
    //     // auth.login(() => {
    //     //   history.push("/createexam");
    //     // });
    //   }catch (error) {
    //     // Show a Swal alert for login failure
    //     swal("Please Contact Admin To Register", "", "error");
    //   }
    // };

  // if (currentUser) {
  //   return <Redirect to="/createexam" />;
  // }

  // const goHome = () => {
  //   history.push('/admin');
  // };

  return (
    <div className="MainDivAdminSignin">
      <img src={logo} alt="logo" className="App-logo" />
      <form onSubmit={handleSubmit} className="login-form">
        <h1>Administrator Access</h1>
        <input type="email" name="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" required />
        <input type="password" name="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" required />
        
        <input type="submit" className="center-block" value="Sign In to Admin Portal" />
        {/* <Button 
          variant="contained" 
          className="home-button" 
          onClick={goHome} 
          style={{ backgroundColor: '#28a745', color: 'white', marginTop: '15px', display: 'block', marginLeft: 'auto', marginRight: 'auto' }}
        >
          Home
        </Button> */}
      </form>
    </div>
  );
}

export default Admin;
